<template>
  <section class="content-section">
    <div class="column animate fadeInDown">
      <div class="row alignCentreRow pathImageCont noMargin">
        <div class="image-container pathImage">
          <img src="@/assets/thePath/path1.jpg" alt="Patricia Ribeiro" />
        </div>
        <p class="animate fadeInDown grey-dark noMarginBottom">
          Patricia Ribeiro is a multidisciplinary artist, mystic, and
          storyteller guided from an early age by a profound sense of purpose.
          Her artistic work is not created from observation but from
          transmission - each narrative, character, and world emerging as a
          direct extension of her consciousness. Her creative identity exists
          across writing, performance, embodiment, and metaphysical exploration,
          allowing her to inhabit and transmit the worlds she creates from the
          inside out.
        </p>
      </div>
      <p class="animate fadeInUp">
        Her insatiable thirst for knowledge and self-mastery shaped the first
        years of her life, immersing her in storytelling, art, and the creation
        of hidden worlds. She devoted herself to understanding consciousness
        through both imagination and discipline, laying the foundation for the
        universe she would later bring into form. Her natural ability to
        perceive patterns, synthesize systems, and translate abstract
        metaphysics into emotional narrative forms became the basis of her
        storytelling language. Her work consistently bridges the invisible and
        the visible, the symbolic and the material, weaving inner cosmology with
        cinematic form.
      </p>
      <blockquote class="animate fadeInRight quote text-right">
        Her commitment to the process
        <span class="bigText textColour">
          led her to her characters
          <span class="bigText textColourWhite"> and her characters </span
          ><span class="bigText emphasis textColour"
            >led her back to her true self</span
          >,
        </span>

        each year of her life was marked by profound involution and evolution,
        with writing as the core of her emotional expression.
      </blockquote>
      <p class="animate fadeInUp">
        Driven by inner sovereignty and a deep knowing that there was something
        only she could bring to this world, she undertook an immersive training
        with Spirit. Her studies spanned esoteric disciplines, metaphysical
        systems, and spiritual technologies, refining her connection to higher
        consciousness, unlocking dormant DNA and ancestral memory, and
        cultivating extra-sensory communication and quantum-mind abilities.
        These practices lifted her from the pulse of not-knowing into a state of
        embodied knowing, shaping a mission centered on creating stories that
        transform the spectator - inviting them not only to watch, but to
        awaken, and allowing the encounter with her work to quietly alter the
        architecture of their inner world.
      </p>

      <div class="image-container">
        <img
          src="@/assets/thePath/thePath2.jpg"
          alt="Patricia Ribeiro"
          class="animate zoomIn"
        />
      </div>
      <blockquote class="byTheTime animate fadeInUpzoomIn alignRight">
        By the time<span class="bigText bold textColourWhite">
          her training </span
        ><span class="bigText emphasis textColour">gave way to mastery</span>
        the forgotten fragments of her puzzle came together and The Path was
        born.
      </blockquote>
    </div>
  </section>
</template>

<script>
export default {
  name: "PatriciaRibeiro",
};
</script>

<style scoped>
.pathImageCont {
  align-items: flex-end;
}

.pathImage {
  height: 40vh !important;
  width: 70% !important;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
}

.content-section {
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-content: stretch;
  margin-bottom: var(--largeSpace);
  padding: var(--largeSpace);
}

.byTheTime {
  align-self: flex-end;
}

.image-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  border-radius: var(--border-radius-medium);
  overflow: hidden;
}

.image-container img {
  width: 100%; /* Ensures the image takes up the full container width */
  object-fit: cover;
}

@media (max-width: 480px) {
  .pathImage {
    height: 666px !important;
    width: 160px !important;
  }
  .pathImageCont {
    transform: translateY(0%);
  }
}
</style>
